/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '@openapi/request';

export class SystemService {

    /**
     * @returns any
     * @throws ApiError
     */
    public static async getSystemInformation(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/system/information`,
        });
        return result.body;
    }

}